import { volunteerUrlBase } from './routes.ts';

/**
 * Generates the path for the volunteer roles listing page.
 */
export const getVolunteerRolesPath = (): string => {
  return volunteerUrlBase;
};

/**
 * Generates the path for a volunteer tour page (role with multiple locations).
 * @param slug - The volunteer role slug
 */
export const getVolunteerTourPath = (slug?: string | null): string => {
  if (!slug) {
    return '';
  }
  return `${volunteerUrlBase}/${slug}`;
};

/**
 * Generates the path for a specific volunteer location/event page.
 * @param slug - The volunteer role slug
 * @param eventId - The event/location identifier
 */
export const getVolunteerLocationPath = (
  slug?: string | null,
  eventId?: string | null,
): string => {
  if (!slug || !eventId) {
    return '';
  }
  return `${volunteerUrlBase}/${slug}/${eventId}`;
};
